export { default } from './SWBusinessAppsBanner';
